import { useQueryClient } from "@tanstack/react-query";

import { getCompanyQueryData, setCompanyQueryData } from "#modules/company/infra/company.query";
import { useUpdateDefaultProcessStep } from "#modules/defaultProcessSteps/view/useUpdateDefaultProcessStep";

type DefaultProcessStepIndex = {
  id: string;
  index: number;
};

export const useReorderDefaultProcessSteps = () => {
  const queryClient = useQueryClient();
  const { updateDefaultProcessStep } = useUpdateDefaultProcessStep();

  const reorderDefaultProcessSteps = (reorderedIndexes: DefaultProcessStepIndex[]) => {
    if (reorderedIndexes.length === 0) {
      return;
    }

    const indexById = new Map(reorderedIndexes.map(({ id, index }) => [id, index]));

    setCompanyQueryData(queryClient, (currentCompany) => {
      const companyToUpdate = currentCompany ?? getCompanyQueryData(queryClient);
      if (!companyToUpdate) {
        return companyToUpdate;
      }

      return {
        ...companyToUpdate,
        companySettings: {
          ...companyToUpdate.companySettings,
          defaultProcessSteps: companyToUpdate.companySettings.defaultProcessSteps.map(
            (processStep) => {
              const newIndex = indexById.get(processStep.id);

              return newIndex === undefined ? processStep : { ...processStep, index: newIndex };
            },
          ),
        },
      };
    });

    reorderedIndexes.forEach(({ id, index }) => {
      updateDefaultProcessStep({ id, payload: { index } });
    });
  };

  return { reorderDefaultProcessSteps };
};
